// Static site links. No download target exists yet, so every store link is
// empty on purpose — StoreButtons renders those buttons disabled rather than
// pointing them at a placeholder. Fill one in once the real URL exists.
export const APK_URL = "";
export const GOOGLE_PLAY_URL = "";
export const APP_STORE_URL = "";
export const URL_BUTTON_LINK = "";

export const WHITE_PAPER_URL = "/docs/whitepaper-en.pdf";

// Legal docs live on the greennova static host.
export const TERMS_URL =
  "https://ex-static.tuuuz.xyz/pdfs/2026/08/07/fb72587a-add2-4886-a066-f147129c654c.pdf";
export const PRIVACY_URL =
  "https://ex-static.tuuuz.xyz/pdfs/2026/08/07/8cd09c4a-e906-4aa1-a93c-5edc6bb3ee9d.pdf";
